module.exports = __webpack_public_path__ + "img/people.01537c43.png";